exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".HyBZfr2RFL7OVXifbvzJV{width:300px}html[dir] .HyBZfr2RFL7OVXifbvzJV{background-color:\"[theme:white, default:#ffffff]\"}._2Q4dKdxSizYaUL2S93J9jc{max-height:470px;overflow-x:hidden}._2tarRb2T3ruY31bYx2guV{overflow:hidden}", ""]);
// Exports
exports.locals = {
	"callout": "HyBZfr2RFL7OVXifbvzJV",
	"scrollContainer": "_2Q4dKdxSizYaUL2S93J9jc",
	"recipientCollection": "_2tarRb2T3ruY31bYx2guV"
};